import { useEffect, useCallback, useMemo } from "react";
import useEventListener from "@use-it/event-listener";
import initialize from "./initialize";

var useDarkMode = function useDarkMode(initialValue, _temp) {
  if (initialValue === void 0) {
    initialValue = false;
  }

  var _ref = _temp === void 0 ? {} : _temp,
      element = _ref.element,
      classNameDark = _ref.classNameDark,
      classNameLight = _ref.classNameLight,
      onChange = _ref.onChange,
      _ref$storageKey = _ref.storageKey,
      storageKey = _ref$storageKey === void 0 ? "darkMode" : _ref$storageKey,
      storageProvider = _ref.storageProvider,
      global = _ref.global;

  var _useMemo = useMemo(function () {
    return initialize(storageKey, storageProvider, global);
  }, [storageKey, storageProvider, global]),
      usePersistedDarkModeState = _useMemo.usePersistedDarkModeState,
      getDefaultOnChange = _useMemo.getDefaultOnChange,
      getInitialValue = _useMemo.getInitialValue,
      mediaQueryEventTarget = _useMemo.mediaQueryEventTarget;

  var _usePersistedDarkMode = usePersistedDarkModeState(getInitialValue(initialValue)),
      state = _usePersistedDarkMode[0],
      setState = _usePersistedDarkMode[1];

  var stateChangeCallback = useMemo(function () {
    return onChange || getDefaultOnChange(element, classNameDark, classNameLight);
  }, [onChange, element, classNameDark, classNameLight, getDefaultOnChange]); // Call the onChange handler

  useEffect(function () {
    stateChangeCallback(state);
  }, [stateChangeCallback, state]); // Listen for media changes and set state.

  /* useEventListener(
    "change",
    ({ matches }) => setState(matches),
    mediaQueryEventTarget
  ) */

  return {
    value: state,
    enable: useCallback(function () {
      return setState(true);
    }, [setState]),
    disable: useCallback(function () {
      return setState(false);
    }, [setState]),
    toggle: useCallback(function () {
      return setState(function (current) {
        return !current;
      });
    }, [setState])
  };
};

export default useDarkMode;